import { Component, OnInit } from '@angular/core';
import { ConcessionarioPessoaStatus, ConcessionarioPessoaStatusLabels } from '@tivic-team/manager-ts/dist/mob/enums/concessionario-pessoa/concessionario-pessoa-status';
import { ParentFormGroup } from 'app/tools/parent-formgroup';

@Component({
  selector: 'dropdown-situacao-concessionario',
  templateUrl: './dropdown-situacao.component.html',
  styleUrls: ['./dropdown-situacao.component.scss'],
  viewProviders:[ParentFormGroup]
})
export class DropdownSituacaoComponent implements OnInit {

  situacao = ConcessionarioPessoaStatusLabels;

  constructor() { }

  ngOnInit() { }

  public selected = this.situacao[ConcessionarioPessoaStatus.ATIVO];

}
